import { useRentalManagerUserTrackingV2WebApiHandler_event } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { MutateOptions } from '@zg-rentals/react-query5';
import type { RentalManagerUserTrackingEvent } from '@zg-rentals/ts-rental-manager-api-client';
import type { RentalManagerUserTrackingV2WebApiHandler_event_Args } from '@zg-rentals/ts-rental-manager-api-client-react-query';

type TrackEventOptions = Parameters<typeof useRentalManagerUserTrackingV2WebApiHandler_event>[0];

type TrackEventMutateOptions = MutateOptions<void, unknown, RentalManagerUserTrackingV2WebApiHandler_event_Args>;

export const useTrackEvent = (options: TrackEventOptions = {}) => {
  const { meta: metaOverrides, ...restOptions } = options;

  const mutation = useRentalManagerUserTrackingV2WebApiHandler_event({
    ...restOptions,
    meta: {
      ...metaOverrides,
      invalidates: [...(metaOverrides?.invalidates ?? [])],
      context: {
        api: 'useRentalManagerUserTrackingV2WebApiHandler_event',
        details: 'useTrackEvent',
        ...metaOverrides?.context,
      },
    },
  });

  const trackEvent = (trackingEvent: RentalManagerUserTrackingEvent, mutateOptions?: TrackEventMutateOptions) =>
    mutation.mutate({ postData: { trackingEvent } }, mutateOptions);

  return { ...mutation, trackEvent };
};
